"use strict";

import Label from "./Label.js";

export default class Labels {
    constructor(props) {
        this.data = props.map((item) => new Label(item));
        this.firstpage = [];
    }

    set(object) {
        this.data = object.map((item) => new Label(item));
    }

    get({ id }) {
        if (id) {
            return this.data.filter((label) => label.get().ID === parseInt(id))[0];
        }
        return this.data;
    }

    renderFirstpageList() {
        const container = document.querySelector(`#labelsSection`);
        const list = container.querySelector(".swiper-wrapper");
        list.textContent = "";
        const elements = 6;
        if (this.data && this.data.length > 0) {
            this.data.map((label, index) => index < elements && list.appendChild(label.renderSwiperListItem()));
        } else {
            if (document.querySelector("#labelsBlock")) {
                document.querySelector("#labelsBlock").remove();
            }
        }
    }

    renderSwiperList() {
        const container = document.querySelector(`#labelsSection`);
        const list = container.querySelector(".swiper-wrapper");
        list.textContent = "";
        this.data.map((label) => list.appendChild(label.renderSwiperListItem()));
    }

    renderList() {
        const container = document.querySelector(`#labelsListSection`);
        const list = container.querySelector(".list-wrapper");
        list.textContent = "";
        this.data.map((label) => list.appendChild(label.renderListItem()));
    }

    renderSingle(id, tracks) {
        const container = document.querySelector(`#labelSection`);
        const label = this.get({ id });
        label.renderSingleItem(container, tracks);
    }

    dispose() {
        this.data = {};
    }
}
